import styled from 'styled-components'

import { SG90T } from '@h2/components/colors'
import { features } from '@h2/components/media'

import { Header } from './header'
import { RecentActivity } from './recentActivity'
import { Info } from './info'
import { Stats } from './stats'
import { Plan } from './plan'

const Wrap = styled.div`
  display: grid;
  grid-template-areas:
    'hdr pln pln pln pln pln pln pln pln pln'
    'act act act sts sts sts sts sts sts sts'
    'act act act inf inf inf inf inf inf inf';
  gap: 20px;
  background-color: ${SG90T};
  padding: 20px;
  border-radius: 5px;

  @media (${features.maxWidth.widescreen}) {
    grid-template-areas:
      'hdr hdr hdr hdr hdr hdr hdr hdr hdr hdr'
      'pln pln pln pln pln pln pln pln pln pln'
      'sts sts sts sts sts sts sts sts sts sts'
      'act act act act act act act act act act'
      'inf inf inf inf inf inf inf inf inf inf'
      \;;
  }
`
const CareerHubOverview = ({ numPerPage }) => {
  return (
    <Wrap>
      <Header />
      <Plan />
      <RecentActivity numPerPage={numPerPage} />
      <Stats />
      <Info />
    </Wrap>
  )
}

export { CareerHubOverview }
